// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3alrr","top":"styles_top__1lq6O"};